import { AGGREGATES } from '@config/aggregates';
import { noop } from '@constants/general';

import { getTransactionType } from '../getTransactionType';

/**
 * @typedef {Object} Row
 * @property {string} id - unique identifier
 * @property {number} totalErrors - totals row errors
 * @property {number} totalWarnings - totals row warnings
 * @property {boolean} runningJob - row has running jobs
 * @property {number} totalNet -  transaction total net
 * @property {number} totalVat - transaction total vat
 * @property {number} totalRows - transaction total rows
 * @property {string} vgTransactionTypeName - transaction type name
 * @property {string} transactionTypeName - client transaction type name
 * @property {{vatRateName: string, goodsServices: string}} vgTransactionType -  transaction type
 */

/**
 * @typedef {Object} BuiltRow
 * @property {string} id - unique identifier
 * @property {number} errorCount - totals row errors
 * @property {number} warningCount - totals row warnings
 * @property {boolean} isProcessing - row is processing
 * @property {string|undefined} troubleshootRoute - troubleshoot route.
 * @property {string} transactionType - transaction type
 * @property {string} transactionTypeName - client transaction type name
 * @property {{totalNet: string, totalVat: string, transactionCount: number}} totals - transaction totals
 */

/**
 *
 * @param {Row} [row={}] - table row data
 * @param {function} [makeRoute=()=>{}] - troubleshoot
 * @returns {BuiltRow}
 */
export const buildRow = (row = {}, makeRoute = () => noop) => {
  const canTroubleshoot = !row?.runningJob && (row?.totalErrors > 0 || row?.totalWarnings > 0);

  const useMassTroubleshoot = !!(
    row?.totalErrors > AGGREGATES.MAX_ERRORS || row?.totalWarnings > AGGREGATES.MAX_ERRORS
  );

  const buildRoute = makeRoute(useMassTroubleshoot);

  return {
    id: row?.id,
    errorCount: row?.totalErrors || 0,
    warningCount: row?.totalWarnings || 0,
    isProcessing: row?.runningJob || false,
    transactionType: getTransactionType(row?.vgTransactionTypeName, row?.vgTransactionType),
    transactionTypeName: row?.clientTransactionTypeName || '',
    totals: {
      totalNet: row?.totalNet,
      totalVat: row?.totalVat,
      transactionCount: row?.totalRows,
    },
    troubleshootRoute: canTroubleshoot ? buildRoute(row?.id) : undefined,
  };
};
